import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import {
  IBilledOrderData,
  IQCFileResponse,
  IDownloadNFEResponse
} from '../long-steel-orders/types';
import { IInvoiceBilletResponse } from '../invoices/types';
import { ECustomerTypeView } from '../user/types';
import {
  ICustomerBilletItem,
  ICustomerQualityCertificateItem,
  ICustomerNFItem,
  Types
} from './types';

export const loadCustomerNfsAndQualityCertificates = (
  customerId: string,
  startDate: string,
  endDate: string,
  customerViewType: ECustomerTypeView
) =>
  action(Types.LOAD_CUSTOMER_NFS_AND_QUALITY_CERTIFICATES, {
    customerId,
    startDate,
    endDate,
    customerViewType
  });

export const loadCustomerNfsAndQualityCertificatesSucces = (
  billedOrders: IBilledOrderData[]
) =>
  action(Types.LOAD_CUSTOMER_NFS_AND_QUALITY_CERTIFICATES_SUCCESS, {
    billedOrders
  });

export const loadCustomerNfsAndQualityCertificatesFailure = (
  error: AxiosError
) =>
  action(Types.LOAD_CUSTOMER_NFS_AND_QUALITY_CERTIFICATES_FAILURE, { error });

export const loadCustomerBillets = (
  customerId: string,
  customerViewType: ECustomerTypeView,
  isManager: boolean,
  startDate: string,
  endDate: string,
  selectedStatus?: string
) =>
  action(Types.LOAD_CUSTOMER_BILLETS, {
    customerId,
    customerViewType,
    isManager,
    startDate,
    endDate,
    selectedStatus
  });

export const loadCustomerBilletsSuccess = (billets: ICustomerBilletItem[]) =>
  action(Types.LOAD_CUSTOMER_BILLETS_SUCCESS, { billets });

export const loadCustomerBilletsFailure = (error: AxiosError) =>
  action(Types.LOAD_CUSTOMER_BILLETS_FAILURE, { error });

export const loadBilletFile = (billetItem: ICustomerBilletItem) =>
  action(Types.LOAD_BILLET_FILE, { billetItem });

export const loadBilletFileSuccess = (
  billetItem: ICustomerBilletItem,
  invoiceBilletResponse: IInvoiceBilletResponse
) =>
  action(Types.LOAD_BILLET_FILE_SUCCESS, {
    billetItem,
    invoiceBilletResponse
  });

export const loadBilletFileFailure = (
  billetItem: ICustomerBilletItem,
  error: AxiosError
) => action(Types.LOAD_BILLET_FILE_FAILURE, { billetItem, error });

export const downloadBilletFile = (billetItem: ICustomerBilletItem) =>
  action(Types.DOWNLOAD_BILLET_FILE, { billetItem });

export const cleanDownloadAreaState = () =>
  action(Types.CLEAN_DOWNLOAD_AREA_STATE);

export const loadQCFile = (
  qualityCertificateItem: ICustomerQualityCertificateItem
) => action(Types.LOAD_QC_FILE, { qualityCertificateItem });

export const loadQCFileSuccess = (
  qualityCertificateItem: ICustomerQualityCertificateItem,
  qcFileResponse: IQCFileResponse
) =>
  action(Types.LOAD_QC_FILE_SUCCESS, {
    qualityCertificateItem,
    qcFileResponse
  });

export const loadQCFileFailure = (
  qualityCertificateItem: ICustomerQualityCertificateItem,
  error: AxiosError
) => action(Types.LOAD_QC_FILE_FAILURE, { qualityCertificateItem, error });
export const loadNFFile = (nfItem: ICustomerNFItem) =>
  action(Types.LOAD_NF_FILE, { nfItem });

export const downloadQCFile = (
  qualityCertificateItem: ICustomerQualityCertificateItem
) => action(Types.DOWNLOAD_QC_FILE, { qualityCertificateItem });

export const loadNFFileSuccess = (
  nfItem: ICustomerNFItem,
  downloadNFEResponse: IDownloadNFEResponse
) => action(Types.LOAD_NF_FILE_SUCCESS, { nfItem, downloadNFEResponse });

export const loadNFFileFailure = (nfItem: ICustomerNFItem, error: unknown) =>
  action(Types.LOAD_NF_FILE_FAILURE, { nfItem, error });

export const downloadNFFile = (nfItem: ICustomerNFItem) =>
  action(Types.DOWNLOAD_NF_FILE, { nfItem });

export const loadNFXMLFile = (nfXmlItem: ICustomerNFItem) =>
  action(Types.LOAD_NF_XML_FILE, { nfXmlItem });

export const loadNFXMLFileSuccess = (
  nfXmlItem: ICustomerNFItem,
  downloadNFEResponse: IDownloadNFEResponse
) => action(Types.LOAD_NF_XML_FILE_SUCCESS, { nfXmlItem, downloadNFEResponse });

export const loadNFXMLFileFailure = (
  nfXmlItem: ICustomerNFItem,
  error: AxiosError
) => action(Types.LOAD_NF_XML_FILE_FAILURE, { nfXmlItem, error });

export const downloadNFXMLFile = (nfXmlItem: ICustomerNFItem) =>
  action(Types.DOWNLOAD_NF_XML_FILE, { nfXmlItem });
